<button
  type="button"
  class="social-btn apple-btn"
  (click)="loginWithApple()"
  aria-label="Entrar com a Apple">
  <span class="icon"><i class="fa-brands fa-apple" aria-hidden="true"></i></span>
</button>
